import React from 'react';
import { FaXTwitter, FaLinkedin, FaGithub } from 'react-icons/fa6';
import './Footer.css';

export function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="social-icons">
          <a
            href="https://x.com/CarlingAidan"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="X profile"
          >
            <FaXTwitter className="footer-icon" />
          </a>
          <a
            href="https://linkedin.com/in/aidan-carling"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn profile"
          >
            <FaLinkedin className="footer-icon" />
          </a>
          <a
            href="https://github.com/AidanCarling"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub profile"
          >
            <FaGithub className="footer-icon" />
          </a>
        </div>
        <p className="footer-copy">
          Copyright © {new Date().getFullYear()} Aidan Carling. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
